module.exports = __webpack_public_path__ + "1793882494189/images/spec-bg.29bc326.png";